// extracted by mini-css-extract-plugin
module.exports = {"mobileLoggedOutMediaQuery":"screen and (max-width: 569px)","mobileLoggedInMediaQuery":"screen and (max-width: 779px)","headerMobileMenuOpenClass":"header--body__menu-open"};